module.exports = __webpack_public_path__ + "static/media/forms.384dfe7b.svg";